import React from 'react'

interface PriceDetailsProps {
  children: React.ReactNode;
}

export function PriceDetails ({ children }: PriceDetailsProps) {
  return <div className='flex gap-2 items-baseline mt-auto'>{children}</div>
}

PriceDetails.displayName = 'MarketplaceCard.PriceDetails'
